import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { NavigationService } from '../../../core/service/navigation.service';
import { SessionService } from '../../../core/service/session.service';

@Injectable()
export class AuthGuard {
  constructor(
    private readonly _session: SessionService,
    private readonly _navigation: NavigationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    if (!this._session.expired()) {
      return true;
    }
    this._session.redirectUrl = state.url;
    this._navigation.navigateLogin();
    return false;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.canActivate(childRoute, state);
  }
}
